import React, { useEffect, useCallback, useState, ReactElement } from "react"
import linksInfo from "./links.json"
import logo from "./logo.svg"
import styles from "./Navigation.scss"

interface IProps {
  animated: boolean
}

function renderLink(href: string, name: string) {
  return (
    <a key={name} href={href}>
      {name}
    </a>
  )
}

function renderLinks() {
  const linkComponents: HtmlElement[] = []

  linksInfo.forEach(({ to, name }: { to: string; name: string }) =>
    linkComponents.push(renderLink(to, name))
  )
  return linkComponents
}

function isScrollYOnTop() {
  return window.scrollY === 0
}

function renderAnimatedHeader(children: ReactElement) {
  const [headerStyle, setHeaderStyle] = useState(styles.staticBlackBg)

  const handler = useCallback(() => {
    setHeaderStyle(
      isScrollYOnTop() ? styles.blackBgAnimation : styles.whiteBgAnimation
    )
  }, [headerStyle])

  useScrollEventListener(handler)
  return (
    <header className={[styles.header, headerStyle].join(" ")}>
      <a href="/">
        <img src={logo} alt="logo" />
      </a>
      {children}
    </header>
  )
}

const Navigation = ({ animated }: IProps) => {
  if (animated) {
    return renderAnimatedHeader(<div>{renderLinks()}</div>)
  }
  return (
    <header
      className={[
        styles.header,
        styles.notStickedToTop,
        styles.staticWhiteBg
      ].join(" ")}
    >
      <a href="/">
        <img src={logo} alt="logo" />
      </a>
      <div>{renderLinks()}</div>
    </header>
  )
}

function useScrollEventListener(handler: EventListenerOrEventListenerObject) {
  useEffect(() => {
    window.addEventListener("scroll", handler)

    return () => {
      window.removeEventListener("scroll", handler)
    }
  })
}

export default Navigation
